export const AnalyticsConstants = {
  //App
  ANALYTICS_EVENT_LOGIN: 'USER_LOGGED_IN',
  ANALYTICS_EVENT_APP: 'USER_APP_OPENED',
  ANALYTICS_EVENT_LOGOUT: 'USER_LOGGED_OUT',

  //Home
  ANALYTICS_EVENT_HOME_SCREEN: 'HOME SCREEN',
  ANALYTICS_EVENT_ONBOARD: 'USER ONBOARDED AND LOGGED IN',
  ANALYTICS_EVENT_UPDATE_TILE_VISIBLE: 'UPDATE APP TILE IS VISIBLE',
  ANALYTICS_EVENT_UPDATE_APP: 'UPDATE APP TILE PRESSED',

  //Schedule
  ANALYTICS_EVENT_SCHEDULE_SCREEN: 'SCHEDULE SCREEN',

  //Shift
  ANALYTICS_EVENT_SHIFT_DETAIL_SCREEN: 'SHIFT DETAIL SCREEN',
  ANALYTICS_EVENT_ADD_SHIFT_SCREEN: 'ADD SHIFT SCREEN',
  ANALYTICS_EVENT_EDIT_SHIFT_SCREEN: 'EDIT SHIFT SCREEN',
  ANALYTICS_EVENT_REQUEST_TIMEOFF_SCREEN: 'REQUEST TIME OFF SCREEN',
  ANALYTICS_EVENT_EDIT_TIMEOFF_REQUEST_SCREEN: 'EDIT TIME OFF REQUEST SCREEN',
  ANALYTICS_EVENT_ADD_SHIFT: 'MANAGER CREATED NEW SHIFT',
  ANALYTICS_EVENT_EDIT_SHIFT: 'MANAGER EDITED SHIFT',
  ANALYTICS_EVENT_ADD_TIME_OFF_REQUEST_MANAGER:
    'MANAGER CREATED TIME OFF REQUEST',
  ANALYTICS_EVENT_ADD_TIME_OFF_REQUEST_HELPER:
    'HELPER CREATED TIME OFF REQUEST',
  ANALYTICS_EVENT_EDIT_TIME_OFF_REQUEST_MANAGER:
    'MANAGER EDITED TIME OFF REQUEST',
  ANALYTICS_EVENT_EDIT_TIME_OFF_REQUEST_HELPER:
    'HELPER CREATED TIME OFF REQUEST',
  ANALYTICS_EVENT_NOT_WORKING_THIS_WEEK_BUTTON_CLICKED:
    'MANAGER NOT WORKING THIS WEEK BUTTON CLICKED',
  ANALYTICS_EVENT_SWAP_SHIFT: 'MANAGER SWAPPED HELPER',
  ANALYTICS_EVENT_ASSIGN_SHIFT: 'MANAGER ASSIGNED SHIFT',
  ANALYTICS_EVENT_TEXT_HELPER: 'MANAGER TEXT HELPER',
  ANALYTICS_EVENT_CANCEL_SHIFT: 'MANAGER CANCELED SHIFT',
  ANALYTICS_EVENT_CALL_HELPER: 'MANAGER CALLED HELPER',
  ANALYTICS_EVENT_CALL_OUT: 'HELPER CALLED OUT',
  ANALYTICS_EVENT_NEXT_SHIFTS: 'HELPER NEXT SHIFTS SCREEN',
  ANALYTICS_EVENT_ADD_CUSTOM_EVENT_SCREEN: 'Add Custom Event Screen',
  ANALYTICS_EVENT_EDIT_CUSTOM_EVENT_SCREEN: 'Edit Custom Event Screen',
  ANALYTICS_EVENT_ADD_CUSTOM_EVENT: 'OBSERVER CREATED NEW CUSTOM EVENT',
  ANALYTICS_EVENT_EDIT_CUSTOM_EVENT: 'OBSERVER EDITED CUSTOM SCREEN',
  //Account
  ANALYTICS_EVENT_ACCOUNT_SCREEN: 'ACCOUNT SCREEN',
  ANALYTICS_EVENT_EDIT_PROFILE_SCREEN: 'EDIT PROFILE SCREEN',
  ANALYTICS_EVENT_SETTINGS_SCREEN: 'SETTINGS SCREEN',

  //Tools
  ANALYTICS_EVENT_TOOLS_SCREEN: 'MANAGER TOOLS SCREEN',

  //Notification
  ANALYTICS_EVENT_NOTIFICATIONS_SCREEN: 'NOTIFICATIONS SCREEN',

  //Open Shifts
  ANALYTICS_EVENT_OPEN_SHIFTS_SCREEN: 'NEXT SHIFTS SCREEN',

  //Chat
  ANALYTICS_EVENT_CHAT_SCREEN: 'CONVERSATIONS SCREEN',
  ANALYTICS_EVENT_CHAT_MESSAGE_SENT: 'CHAT MESSAGE SENT',
  ANALYTICS_EVENT_CHAT_MESSAGE_RESEND: 'CHAT MESSAGE RESENT',
  ANALYTICS_EVENT_CHAT_DIRECT_MESSAGE_RESEND: 'DIRECT MESSAGE RESENT',
  ANALYTICS_EVENT_DIRECT_MESSAGE_SENT: 'DIRECT MESSAGE SENT',

  ANALYTICS_PROPERTY_NAME: 'NAME',
  ANALYTICS_PROPERTY_GROUP_TYPE: 'GROUP TYPE',
  ANALYTICS_PROPERTY_GROUP_NAME: 'GROUP NAME',
  ANALYTICS_PROPERTY_GROUP_ID: 'GROUP ID',
  ANALYTICS_PROPERTY_USER_ID: 'USER ID',
  ANALYTICS_PROPERTY_MESSAGE_ID: 'MESSAGE ID',

  //FILTERS
  ANALYTICS_EVENT_SAVE_FILTERS_SCREEN: 'SAVE FILTERS SCREEN',
  ANALYTICS_EVENT_SAVE_FILTER: 'FILTER SAVED',
}
